/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import { string } from 'prop-types';
import { useHistory } from 'react-router-dom';

import Button from 'components/Button/Button';
import BlackTieIcon from 'components/BlackTieIcon/BlackTieIcon';

import styles from './back-button.scss';

/**
 * This is the BackButton component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export const BackButton = ({ customPath }) => {
  const history = useHistory();

  const onClick = event => {
    event.preventDefault();

    if (customPath) {
      return history.push(customPath);
    }

    return history.goBack();
  };

  return (
    <Button onClick={onClick} className={styles.wrapper} icon dark small>
      <BlackTieIcon icon="times" weight="btb" className={styles.icon} />
    </Button>
  );
};

BackButton.propTypes = {
  customPath: string,
};

BackButton.defaultProps = {
  customPath: null,
};

export default BackButton;
